export default __webpack_public_path__ + "static/media/3.907647bf.jpg";